import { render, staticRenderFns } from "./UnsavedChangesPopup.vue?vue&type=template&id=aa3c046a"
import script from "./UnsavedChangesPopup.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports